/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipiRimborsoResponseDTO
 */
export interface TipiRimborsoResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof TipiRimborsoResponseDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TipiRimborsoResponseDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the TipiRimborsoResponseDTO interface.
 */
export function instanceOfTipiRimborsoResponseDTO(value: object): value is TipiRimborsoResponseDTO {
    return true;
}

export function TipiRimborsoResponseDTOFromJSON(json: any): TipiRimborsoResponseDTO {
    return TipiRimborsoResponseDTOFromJSONTyped(json, false);
}

export function TipiRimborsoResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipiRimborsoResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function TipiRimborsoResponseDTOToJSON(json: any): TipiRimborsoResponseDTO {
    return TipiRimborsoResponseDTOToJSONTyped(json, false);
}

export function TipiRimborsoResponseDTOToJSONTyped(value?: TipiRimborsoResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'descrizione': value['descrizione'],
    };
}

